export default "__VITE_ASSET__CynSetKO__"